import { render, staticRenderFns } from "./PurchaseApplication.vue?vue&type=template&id=2bf39188&scoped=true&"
import script from "./PurchaseApplication.vue?vue&type=script&lang=js&"
export * from "./PurchaseApplication.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseApplication.vue?vue&type=style&index=0&id=2bf39188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf39188",
  null
  
)

export default component.exports